var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"iframe",attrs:{"id":"iframe","src":_vm.url}}),_c('view',{staticClass:"downloadBtn"},[_c('view',[_vm._v("文件下载")])])])}
var staticRenderFns = []

export { render, staticRenderFns }